angular
  .module("app")
  .controller("InstantLeasingCtrl", function (
    $scope,
    $instantLeasingService,
    $modalService,
    InstantModel,
    $location,
    $transactionFactory,
    $searchUserService,
    RiUserG,
    Fatturazione,
    $rootScope,
    DocumentazioneAggiuntiva,
    Pf,
    $userService,
    $configService,
    Comune
  ) {
    $scope.$modalService = $modalService;
    var self = this;
    self.cervedUpdate = false;
    $scope.enableButton = true;

    var init = function () {
      $scope.pep = {
        selected: false
      }
      $scope.canProceed = false;
      $scope.loading = false;
      $scope.finito = false;
      $scope.instantModel = $transactionFactory.get();
      $scope.formaGiuridica = "";
      $scope.proposta = "Proposta N°.: " + $scope.instantModel.appIlTransaction.id;
      $scope.poteriFirma = $scope.instantModel.financialCustomer.metadata.riUserF.poteriFirma;
      $scope.societyStructureAccepted = false;
    };

    init();
    /**
     * Navigation
     */
    $scope.navigator = {
      getPageIndex: function () {
        return $scope.instantModel.viewIndex;
      },
      nextPage: function () {
        /**
         * If view index is 0, call insert instance,
         */
        $scope.enableLoaderNextPage = true;
        if ($scope.instantModel.viewIndex === 0) {
          //Gets idWfInstance from the current transaction
          var currentTransaction = $transactionFactory.get();

          $scope.instantModel.idWfInstance = currentTransaction.idWfInstance;
          $scope.instantModel.idAppVendor = currentTransaction.identifierVendor;

          $scope.proposta = "Proposta N°: " + $scope.instantModel.appIlTransaction.id;

          var updatedModel = InstantModel.build($scope.instantModel);

          $instantLeasingService
            .nextStep(updatedModel)
            .then(function (newInstantModel) {

              if (newInstantModel.financialCustomer.metadata.riUserG.sedeFatturazione.indirizzo &&
                newInstantModel.financialCustomer.metadata.riUserG.sedeFatturazione.numeroCivico &&
                newInstantModel.financialCustomer.metadata.riUserG.sedeConsegna.indirizzo &&
                newInstantModel.financialCustomer.metadata.riUserG.sedeConsegna.numeroCivico) {
                $scope.instantModel = newInstantModel;
                $scope.enableLoaderNextPage = false;
              } else {
                $searchUserService
                  .getAppUserFromCerved(
                    $transactionFactory.get().appIlTransaction.id
                  )
                  .then(function (appCustomerUser) {
                    if (appCustomerUser) {
                      appCustomerUser.metadata.riUserG.sedeLegale.luogoEsteso = Comune.build({
                        nome: appCustomerUser.metadata.riUserG.sedeLegale.comune,
                        cap: appCustomerUser.metadata.riUserG.sedeLegale.cap,
                        sigla: appCustomerUser.metadata.riUserG.sedeLegale.provincia
                      });
                      appCustomerUser.metadata.riUserG.sedeFatturazione.luogoEsteso = Comune.build({
                        nome: appCustomerUser.metadata.riUserG.sedeFatturazione.comune,
                        cap: appCustomerUser.metadata.riUserG.sedeFatturazione.cap,
                        sigla: appCustomerUser.metadata.riUserG.sedeFatturazione.provincia
                      });


                      var fatturazione = newInstantModel.financialCustomer.metadata.riUserG.sedeFatturazione.fatturazione;
                      //aggiorno il metadato con i dati del cliente, se già noto
                      var newCustomerMetadata = Object.assign(
                        newInstantModel.financialCustomer.metadata, {
                          riUserG: RiUserG.build(appCustomerUser.metadata.riUserG)
                        }
                      );
                      newInstantModel.financialCustomer.metadata = newCustomerMetadata;
                      $scope.instantModel = newInstantModel;
                    }
                    $scope.enableLoaderNextPage = false;
                  })
                  .catch(function (err) {
                    console.log("spaccato: ", err);
                    $scope.enableLoaderNextPage = false;
                  })
                  .finally(function () {
                    console.info("finito getAppUserFromCerved");

                  });
              }
            })
            .catch(function (err) {
              console.log("spaccato: ", err);
              $scope.enableLoaderNextPage = false;
            })
            .finally(function () {
              console.info("finito nextStep");

            });
        } else if ($scope.instantModel.viewIndex === 2) {
          $scope.enabledModalInvites = false;
          $scope.instantModel.financialCustomer.metadata.riUserF.listaPf
            .forEach(function (pf) {
              if (pf.cf == $scope.dealerUser.identifier) {
                return pf.dealer = true;
              } else {
                return pf.dealer = false;
              }
            })
          $instantLeasingService
            .checkRichiestaIL(
              $scope.instantModel,
              $scope.instantModel.appIlTransaction
            )
            .then(function (popupEnum) {
              $scope.ragSocialeFornitore = $instantLeasingService.getAllInfoFromCheckRichiestaIL().ragSocFornitore;
              $scope.textMessage = $instantLeasingService.getDetails().checkDetails;
              //Reset a previous asssertion
              $scope.societyStructureAccepted = false;
              $scope.instantModel.financialCustomer.metadata.riUserF.poteriFirma = $instantLeasingService.getDetails().firmatari;
              $scope.poteriFirma = $instantLeasingService.getDetails().firmatari;
              switch (popupEnum) {
                case "false":
                  $instantLeasingService
                    .nextStep($scope.instantModel)
                    .then(function (newInstantModel) {
                      $scope.instantModel = newInstantModel;
                      $scope.enableLoaderNextPage = false;
                    })
                    .catch(function (err) {
                      console.log(err);
                      $scope.enableLoaderNextPage = false;
                    })
                    .finally(function () {

                    });
                  break;

                case "pop1":
                  $scope.enabledModalInvites = true;
                  $scope.enableLoaderNextPage = false;
                  $modalService.openModal("instant-popup1");
                  break;

                case "pop2":
                  $scope.enableLoaderNextPage = false;
                  $modalService.openModal("instant-popup2");
                  break;

                default:
                  $scope.enableLoaderNextPage = false;
                  break;
              }
            })
            .catch(function (error) {
              console.log(error);
              $scope.enableLoaderNextPage = false;
            })
            .finally(function () {});
        } else {
          /**
           * call nextStep instead
           */
          $instantLeasingService
            .nextStep($scope.instantModel)
            .then(function (newInstantModel) {
              $scope.instantModel = newInstantModel;
              $scope.enableLoaderNextPage = false;
            })
            .catch(function (err) {
              console.log(err);
              $scope.enableLoaderNextPage = false;
            })
            .finally(function () {

            });
        }
      },
      back: function () {
        var self = this;
        /**
         * call backStep
         */
        $scope.enableLoaderBackPage = true;
        $instantLeasingService
          .backStep($scope.instantModel)
          .then(function (newInstantModel) {
            console.log("new model returned: ", newInstantModel);
            $scope.instantModel = newInstantModel;
            $scope.enableLoaderBackPage = false;
          })
          .catch(function (err) {
            console.log(err);
            $scope.enableLoaderBackPage = false;
          });
      },
      suspend: function () {
        var self = this;
        var saveInstance = true;
        // $instantLeasingService
        //   .suspendInstance($scope.instantModel)
        //   .then(function (success) {
        //     if (success) {
        //       $modalService.closeModal("suspendInstance");
        //       $location.path("/");
        //     }
        //   })
        //   .catch(function (err) {
        //     console.log("suspend instance failed! Error cause was: " + err);
        //   });
        $instantLeasingService
          .nextStep($scope.instantModel, saveInstance)
          .then(function (newInstantModel) {
            $modalService.closeModal("suspendInstance");
            $location.path("/");
          })
          .catch(function (err) {
            console.log(err);

          })
          .finally(function () {});
      },
      finish: function () {
        var self = this;
        $scope.enableLoaderNextPage = true;
        $instantLeasingService
          .submitRequest($scope.instantModel)
          .then(function (response) {
            console.log("response: ", response);
            $scope.enableLoaderNextPage = false;
            if (response) {
              $location.path("/");
            }
          })
          .catch(function (err) {
            console.log("err: ", err);
            $scope.enableLoaderNextPage = false;
            $rootScope.$broadcast("addAlert", {
              text: 'ERROR_TEC'
            });
          })
          .finally(function () {});
      }
    };

    /** end Navigation **/

    //pagina uno
    $scope.onProductChosen = function (instantModel) {
      $scope.instantModel = instantModel;
      $scope.finito = true;
      console.log("InstantModel: ", instantModel);
    };
    $scope.sendRentChosen = function (rata) {
      console.log("Il valore della rata selezionato: ", rata);
      $scope.instantModel.rata = rata;
      $scope.instantModel = InstantModel.build($scope.instantModel);
      $scope.enableButton = false;
    };

    //pagina due
    $scope.operation_type = "OPERATIVO";

    $scope.fattElettronica = function (value, result) {
      if (result === true) {
        $scope.fattElettronicaEnabled = true;
      } else {
        $scope.fattElettronicaEnabled = false;
      }

      $scope.instantModel.financialCustomer.metadata.riUserG.sedeFatturazione.fatturazione = Fatturazione.build(
        value
      );
    };

    $scope.onPrivacyOk = function (value) {
      $scope.instantModel.financialCustomer.metadata.privacy =
        value;
      if (value) {
        $scope.privacyIsEnabled = true;
      }
    };

    $scope.onPrivacyNotOk = function () {
      $scope.privacyIsEnabled = false;
    };

    $scope.catSelected = function (value) {
      $scope.categoriaSelezionata = value;
      $scope.instantModel.financialCustomer.metadata.categoria = value;
      $scope.instantModel = InstantModel.build($scope.instantModel);
      if (value) {
        $scope.questionarioOk = true;
      }
    };

    $scope.enabledNextButton = function () {
      return (
        $scope.fattElettronicaEnabled &&
        $scope.privacyIsEnabled &&
        $scope.categoriaSelezionata
      );
    };

    $scope.validationObj = {
      documentDate: {
        disabledDays: "2",
        disabledDates: "12/12/2020"
      }
    };

    //Pagina 2 - riUserG
    $scope.accordionDatiClienteChanges = function (datiCliente, result) {
      $scope.instantModel.financialCustomer.metadata.riUserG = datiCliente;
      $scope.riUserGOk = result;
    };

    $scope.enabledNextButtonOnboarding = function () {
      return (
        $scope.riUserGOk &&
        $scope.fattElettronicaEnabled &&
        $scope.privacyIsEnabled &&
        $scope.questionarioOk
      );
    };

    $scope.enableButtonRiUserF = function () {
      return $scope.riUserFOk && $scope.ibanOk;
    };

    $scope.ibanOk = function (iban) {
      //TODO update iban into instant model!
      $scope.ibanOk = true;
    };

    //pagina 3 - riUserF
    $scope.individualsOk = function () {
      $scope.enableIndividualsAndAuthorizations = true;
    };
    $scope.individualsNotOk = function () {
      $scope.enableIndividualsAndAuthorizations = false;
    };
    $scope.ibanIsNotOk = function () {
      $scope.checkIban = false;
    };
    $scope.ibanIsOk = function () {
      $scope.checkIban = true;
    };

    $scope.enableButtonIndividualAuthorizations = function () {
      return $scope.enableIndividualsAndAuthorizations && $scope.checkIban;
    };

    $scope.acceptSocietyStructure = function () {
      $scope.societyStructureAccepted = true;
    };

    $scope.undoTransaction = function () {
      $instantLeasingService
        .undoTransaction($scope.instantModel.appIlTransaction.id)
        .then(function (success) {
          if (success) {
            $modalService.closeModal("instant-popup2");
            $location.path("/");
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {});
    };

    $scope.inviteAssociate = function () {
      $scope.loaderInvitePerson = true;
      var lilstaPf = $scope.instantModel.financialCustomer.metadata.riUserF.listaPf
        .filter(function (element) {
          return element.cf != $scope.dealerUser.identifier;
        })
      $instantLeasingService.inviteAssociate($scope.instantModel.appIlTransaction, lilstaPf)
        .then(function (response) {
          console.log(response);
          $scope.loaderInvitePerson = false;
          $modalService.closeModal("instant-popup1");
        })
        .catch(function (error) {
          console.error(error);
          $scope.loaderInvitePerson = false;
          $modalService.closeModal("instant-popup1");
        })
        .finally(function () {

        });
    };

    $scope.isTitOrFir = function (pf) {
      pf = Pf.build(pf);

      if (pf.isTitolare() && pf.isFirmatario()) {
        result = "titolare e firmatario";
      } else if (pf.isTitolare()) {
        result += "titolare";
      } else {
        result += "firmatario";
      }

      return result;
    };

    $userService.getDealerUser()
      .then(function (dealer) {
        if (dealer) {
          $scope.dealerUser = dealer;
        }
      });

    //pagina 4
    $scope.selectedAdeguataVerifica = function (item) {
      $scope.instantModel.financialCustomer.metadata.adeguataVerifica = item;
      $scope.instantModel = InstantModel.build($scope.instantModel);
      $scope.enableButtonAppropriateVerification = true;
    };

    $scope.invalidNextPageAppropriateVerification = function () {
      $scope.enableButtonAppropriateVerification = false;
    };

    $scope.enabledNextPageAppropriateVerification = function () {
      if ($scope.instantModel.financialCustomer.metadata.riUserF.poteriFirma != "MANUAL") {
        $scope.enalbeButtonUpload = true;
      }
      return (
        $scope.enableButtonAppropriateVerification && $scope.enalbeButtonUpload
      );
    };

    $scope.upLoadOk = function (document) {
      var temp = {};
      temp.listaDoc = document;
      $scope.instantModel.documentazioneAggiuntiva = DocumentazioneAggiuntiva.build(
        temp
      );
      $scope.enalbeButtonUpload = true;
    };

    $scope.upLoadNotOk = function (document) {
      var temp = {};
      temp.listaDoc = document;
      $scope.instantModel.documentazioneAggiuntiva = DocumentazioneAggiuntiva.build(
        temp
      );
      $scope.enalbeButtonUpload = false;
    };

    $scope.privacy = {
      documentoPrivacyFirmato: {
        selected: false,
        nameFile: ""
      }
    };

    $scope.canProceedInvitePerson = function () {
      $scope.canProceed = true;
    }
    $scope.cantProceedInvitePerson = function () {
      $scope.canProceed = false;
    }

    $scope.checkPepInvites = function (el) {
      el.selected = !el.selected;
    }

    $scope.linkPep = $configService.getAppConfig().url +
      '/uni/download/service-infos/' +
      encodeURIComponent('GLOSSARIO') + '/?token=' +
      $configService.getAppConfig().token;

  });